import React, {createContext, useState, useEffect} from "react";

export const PokemonContext = createContext();

export const PokemonProvider = ({children}) => {
    const [pokemonList, setPokemonList] = useState([])
    const [selectedPokemon, setSelectedPokemon] = useState(null);
    const [reset, setReset] = useState(false)

    useEffect(() => {
        const fetchPokemon = async () => {
          const res = await fetch('https://pokeapi.co/api/v2/pokemon?limit=151');
          const pokemon = await res.json();
          if (res.status === 200) {
            // Fetch details for each Pokémon concurrently
            const fetchDetails = pokemon.results.map(async (poke) => {
              const singleRes = await fetch(poke.url);
              if (singleRes.status === 200) {
                return await singleRes.json();
              }
              return null; // Handle failed fetch
            });
    
            // Wait for all details to be fetched
            const allPokemon = await Promise.all(fetchDetails);
            setPokemonList(allPokemon.filter(pokemon => pokemon !== null));
          }
        };
    
        fetchPokemon();
      }, [reset]);

      const getNewPokemon = async (start,end) => {
        const urls = [];
        for (let id = start; id <= end; id++) {
          urls.push(`https://pokeapi.co/api/v2/pokemon/${id}/`);
        }

        const fetchDetails = urls.map(async (url) => {
          const singleRes = await fetch(url);
          if (singleRes.status === 200) {
            return await singleRes.json();
          }
          return null; // Handle failed fetch
        });
         // Wait for all details to be fetched
      const newPokemon = await Promise.all(fetchDetails);
       setPokemonList([...pokemonList, ...newPokemon.filter(pokemon => pokemon !== null)])

        console.log(urls)
      }

      // getNewPokemon()

      const selectPokemon = (pokemon) => {
        setSelectedPokemon(pokemon);
      }

      return (
        <PokemonContext.Provider value={{ pokemonList, selectedPokemon, selectPokemon, setPokemonList, getNewPokemon, setReset }}>
            {children}
        </PokemonContext.Provider>
      )
}